import { render, staticRenderFns } from "./appRolesSelect.vue?vue&type=template&id=3ac5e7b9"
import script from "./appRolesSelect.vue?vue&type=script&lang=js"
export * from "./appRolesSelect.vue?vue&type=script&lang=js"
import style0 from "./appRolesSelect.vue?vue&type=style&index=0&id=3ac5e7b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports